import { formatDate } from "@angular/common";
import { LOCALE_ID } from '@angular/core';

export class DateHelper {


  public static parseDate(date: string) {

    try {
      let dateObj = new Date(date);

      if (Number.isNaN(dateObj.getMonth())) {
        // console.error("cannot parse date isNaN : " + date);

        // "2021-11-19 07:38:56Z"

        const [dateparts, timeparts] = date.substring(0, date.length - 1).split(" ");
        // console.error("dateparts : " + dateparts);
        // console.error("timeparts : " + timeparts);
        const [year, month, day] = dateparts.split("-");
        // console.error("year : " + year);
        // console.error("month : " + month);
        // console.error("day : " + day);
        const [hours = 0, minutes = 0, seconds = 0] = timeparts?.split(":") ?? [];
        // console.error("hours : " + hours);
        // console.error("minutes : " + minutes);
        // console.error("seconds : " + seconds);
        // Treats the string as UTC, but you can remove the `Date.UTC` part and use
        // `new Date` directly to treat the string as local time
        return new Date(Date.UTC(+year, +month - 1, +day, +hours, +minutes, +seconds));
      }

      return dateObj;

    } catch (e: unknown) {
      // console.error("cannot parse date : " + date);
    }

    return new Date();
  }

  public static formatDateRFC3339(date: Date) {

    //return formatDate(date, "yyyy-MM-dd'T'HH:mm:ssXXX", $localize`:@@dateHelper_locale:IT_it`);
    return DateHelper.toISODateString(date);
  }

  public static formatDateFriendly(date: Date) {

    try {
      // console.log("formatDateFriendly: " + date);
      return formatDate(date, "EEE d MMMM yyyy", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatDateFriendly " + date);
    }
    return "?";
  }


  public static formatDateFriendlyWithHour(date: Date) {

    try {
      // console.log("formatDateFriendlyWithHour: " + date);
      return formatDate(date, "HH:mm - EEE d MMMM yyyy", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatDateFriendlyWithHour " + date);
    }
    return "?";
  }

  public static formatDateFriendlyWithHourValidityCheck (date: Date) {
    try {
      // console.log("formatDateFriendlyWithHour: " + date);
      if( Number(date.getFullYear()) > 2000){
        return formatDate(date, "HH:mm - EEE d MMMM yyyy", $localize`:@@dateHelper_locale:IT_it`);
      } else {
        return false;
      }
    } catch (e: unknown) {
      // console.error("cannot parse date formatDateFriendlyWithHour " + date);
    }
    return false;
  }

  public static formatAccessLogApi(date: Date) {

    try {
      // console.log("formatAccessLogApi: " + date);

      // 2020-12-09T16:09:53+00:00
      return formatDate(date, "YYYY-MM-dd\'T\'HH:mm:ss\'+00:00\'", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatAccessLogApi " + date);
    }
    return "?";
  }


  public static formatDateForApi(date: Date) {

    try {
      // console.log("formatDateForApi: " + date);
      // return formatDate(date, "YYYY-MM-ddTHH:mm:ssZZZZZ", $localize`:@@dateHelper_locale:IT_it`);
      return DateHelper.toISODateString(date);
      // return formatDate(date, "YYYY-MM-ddTHH:mm:ss", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatDateForApi " + date);
    }
    return "?";
  }

  public static formatShortDateFriendly(date: Date) {

    try {
      // console.log("formatShortDateFriendly: " + date);

      return formatDate(date, "dd/MM/yyyy", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatShortDateFriendly " + date);
    }
    return "?";
  }

  public static formatDateTimeFriendly(date: Date) {

    try {
      // console.log("formatDateTimeFriendly: " + date);

      return formatDate(date, "EEE d MMMM yyyy HH:mm:ss", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatDateTimeFriendly " + date);
    }
    return "?";
  }


  public static formatDateTimeShortFriendly(date: Date) {

    try {
      // console.log("formatDateTimeFriendly: " + date);

      return formatDate(date, "EEE d MMMM yyyy HH:mm", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatDateTimeFriendly " + date);
    }
    return "?";
  }

  public static formatTimeFriendly(date: Date) {

    try {
      // console.log("formatTimeFriendly: " + date);

      return formatDate(date, "HH:mm", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date formatTimeFriendly " + date);
    }
    return "?";
  }

  protected static toISODateString(d) {

    return d.getUTCFullYear() + '-'
      + DateHelper.pad(d.getUTCMonth() + 1) + '-'
      + DateHelper.pad(d.getUTCDate()) + 'T'
      + DateHelper.pad(d.getUTCHours()) + ':'
      + DateHelper.pad(d.getUTCMinutes()) + ':'
      + DateHelper.pad(d.getUTCSeconds()) + 'Z'
  }

  protected static pad(n) {
    return n < 10 ? '0' + n : n
  }

  public static getDateMonth(date: Date) {
    try {
      // console.log("getDateMonth: " + date);

      return formatDate(date, "MMMM", $localize`:@@dateHelper_locale:IT_it`);

    } catch (e: unknown) {
      // console.error("cannot parse date getDateMonth " + date);
    }
    return "?";
  }
}
